import { useCallback } from "react";

import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";

import { SellOrderPageConnector } from "@pages/sell-order/sell-order-page-connector";
import { FeatureFlag } from "@shared/feature-toggle/default-flags";

import { Route as OrderRoute } from "./orders/$id";
import { Route as RequisiteRoute } from "./requisites/index";

export const Route = createFileRoute("/_private/sell")({
  beforeLoad: ({ context }) => {
    if (!context.hasFeatureFlag(FeatureFlag.FT_SELL_FLOW)) {
      throw redirect({ to: "/" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { history, navigate } = useRouter();
  const onGoOrder = useCallback(
    (id: string) => {
      navigate({
        params: {
          id,
        },
        to: OrderRoute.fullPath,
      });
    },
    [navigate],
  );

  const onGoAddNewRequisite = useCallback(() => {
    navigate({
      search: {
        state: "add",
      },
      to: RequisiteRoute.fullPath,
    });
  }, [navigate]);

  return (
    <SellOrderPageConnector
      onGoAddNewRequisite={onGoAddNewRequisite}
      onGoBack={history.back}
      onGoOrder={onGoOrder}
    />
  );
}
